import React, { Component } from 'react'

export default class SamplePage extends Component {
    render() {
        return (
            <main className="page">
                <div className="content">
                    <h2 className="head-shadow">SamplePage</h2>
                    <h3 className="head">Not found</h3>
                </div>
            </main>
        )
    }
}
